/// <reference path="../_references.ts"/>

module App.Administrative.UploadPhotos {
	angular
		.module('administrative.upload-photos', [])
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
			$stateProvider
				.state('zipSolutions.old.uploadPhotos', {
					url: '/administrative/uploadPhotos',
					redirectTo: 'zipSolutions.administrative.upload-photos',
				})
				.state('zipSolutions.administrative.upload-photos', {
					url: '/upload-photos',
					data: {
						title: 'Upload Photos',
					},
					views: {
						'content@': {
							controller: 'UploadPhotosController',
							controllerAs: 'ctrl',
							templateUrl: 'html/administrative/upload-photos/upload-photos.html',
						},
					},
				});
		}])
		.controller('UploadPhotosController', UploadPhotosController);
}